const onboardingEN = {
	/* ---------- COMMON ---------- */
	showSteps: "Show steps",
	hideSteps: "Hide steps",
	stepsCompleted: "steps completed",

	/* ---------- BANNER ---------- */
	bannerTitle: "Complete your shop setup",
	bannerSubtitle: "finish to start accepting bookings",

	/* ---------- BUBBLE / HINT ---------- */
	hintTitle: "Complete your setup",
	hintText: "Finish these steps to activate your shop and start accepting bookings.",

	/* ---------- OWNER / ADMIN ---------- */
	launchShop: "Launch Shop",
	launching: "Redirecting...",
	errors: {
		billing: "Unable to start billing",
	},
	steps: {
		shopInfo: "Shop Information",
		schedule: "Owner Schedule",
		services: "Add Services",
		images: "Upload Images",
		openingHours: "Opening Hours",
		contactInfo: "Contact Info",
		attributes: "Attributes",
	},

	/* ---------- STAFF ---------- */
	staff: {
		bannerTitle: "Complete your staff profile",
		bannerSubtitle: "finish to start accepting bookings",
		launch: "Launch Staff Profile",
		launching: "Launching...",
		steps: {
			schedule: "Employee Schedule",
			services: "Link Services",
		},
		messages: {
			success: "Staff profile activated!",
			error: "Failed to launch staff profile. Try again.",
		},
	},
};

export default onboardingEN;